<div class="mini-footer-container {{vars.pageName}}">
    <div class="content">
        <span class="title">
            Copyright © {{currentYear}} {{vars.domain_details.name}}. All Rights Reserved.
        </span>
        <span class="desc">
            {{vars.domain_details.name}} (Equal Aid for Equal Lives, Inc) is a California-registered 501(c)(3) nonprofit
            organization (EIN 93-3691588).
        </span>
    </div>
</div>